const keyMirror = require("keymirror");

export const CostsConstants = keyMirror({
  SET_COSTS: undefined,
});
